// Vendor
import type { UseFetchOptions } from "nuxt/app";

// Constants
import { COOKIE_ID_TOKEN } from "~/shared/constants";

export function useGoodBitsFetch<Response>(
  url: Ref<string> | string,
  options?: UseFetchOptions<Response>,
) {
  const { public: publicConfig } = useRuntimeConfig();
  const idToken = useCookie(COOKIE_ID_TOKEN);

  return useFetch(url, {
    ...options,
    $fetch: $fetch.create({
      baseURL: publicConfig.goodbitsUrl,
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": publicConfig.goodbitsKey,
      },
    }),
    onRequest: ({ options }) => {
      if (idToken.value) {
        options.headers.set("Authorization", `Bearer ${unref(idToken)}`);
      }
    },
  });
}
